module.exports = __webpack_public_path__ + "static/media/inspect-video-poster.09bd6f95.jpg";